import React from 'react'

import { IconDeviceDesktop, IconDeviceMobile } from '../../svg'
import EditorMain from './Editor.js'

class PreviewTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            device: 'desktop',
        }
        this.previewRef = React.createRef()
    }

    async componentDidMount() {
        this.showFrame(this.state.device)
    }

    showFrame = async function (device) {
        const json = await EditorMain.serializeProject(),
            projectTypeData = EditorMain.getProjectType()

        new window.RemixContainer({
            mode: 'preview',
            element: this.previewRef.current,
            url: projectTypeData.html,
            scriptUrl: projectTypeData.script,
            cssUrl: projectTypeData.css,
            commonjsUrl: projectTypeData.commonjs,
            width: device === 'mobile' ? 320 : 800,
            height: EditorMain.getProjectConfig().height || 600,
            containerLog: true,
            defaults: JSON.stringify(json),
            forceRestart: true,
        })
    }

    componentWillUnmount() {}

    handleClick__change_preview_device = value => async evt => {
        evt.preventDefault()
        await this.setState(() => {
            this.showFrame(value)
            return { device: value }
        })
    }

    render() {
        const { device } = this.state
        const blockeditor = EditorMain.getProjectConfig().isBlockEditor ? 'blockeditor' : ''

        return (
            <div className="editor-tab--preview">
                <ul className="device-changer">
                    <li
                        className={`desktop${device === 'desktop' ? ' is-active' : ''}`}
                        onClick={this.handleClick__change_preview_device('desktop')}
                    >
                        <IconDeviceDesktop />
                    </li>
                    <li
                        className={`mobile${device === 'mobile' ? ' is-active' : ''}`}
                        onClick={this.handleClick__change_preview_device('mobile')}
                    >
                        <IconDeviceMobile />
                    </li>
                </ul>
                <div className={`iframe_wrapper ${device} ${blockeditor}`}>
                    <div className={`iframe_inner ${blockeditor}`}>
                        <div ref={this.previewRef}></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PreviewTab
